import React, { useContext, useEffect, useState } from "react";
import TkLabelText from "../../atoms/TkLabelText";
import { ITkTextAreaProps } from "../../../type/componentsType/TkTextArea";
import { TkFormContext } from "../../../context/tkFormContext";

/**
 * TkTextAreaは、複数行のプレーンテキスト編集コントロールです。
 *
 * @param {ITkTextAreaProps} props - TkTextAreaコンポーネントのプロパティ
 * @param rows- テキストエリアの行数
 * @param rest - その他のTkLabelTextプロパティ
 */
const TkTextArea = React.forwardRef<HTMLTextAreaElement, ITkTextAreaProps>(
  (props, ref: any) => {
    const {
      rows,
      inputProps,
      onChange,
      showLimt,
      onGetInputValue,
      error,
      helperText,
      ...rest
    } = props;

    const { formContext, setFormContext } = useContext(TkFormContext);
    const [textLength, setTextLength] = useState(0);
    const [value, setValue] = useState("");
    const [limitError, setLimitError] = useState(false);

    useEffect(() => {
      if (inputProps?.maxLength) {
        setTextLength(inputProps.maxLength);
      } else {
        setTextLength(0);
      }
    }, [inputProps?.maxLength]);

    useEffect(() => {
      setLimitError(!!error);
    }, [error]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const inputValue = e.target.value;
      if (inputProps?.maxLength && inputValue?.length > inputProps.maxLength) {
        setLimitError(true);
        setFormContext?.({ preventSubmit: { textarea: true } });
      } else {
        setLimitError(false);
        if (formContext?.preventSubmit?.textarea === true) {
          setFormContext?.({
            preventSubmit: {
              ...formContext.preventSubmit,
              textarea: false
            }
          });
        }
      }
      setValue(inputValue);
      onChange && onChange(e);
    };

    return (
      <TkLabelText
        fullWidth={rest.fullWidth || true}
        multiline
        rows={rows || 4}
        {...rest}
        error={limitError || error}
        onChange={handleChange}
        onGetInputValue={onGetInputValue}
        inputProps={{ ...inputProps, "data-testid": "TkLabelTextTestId" }}
        ref={ref}
        helperText={
          helperText
            ? helperText
            : textLength && showLimt && `${value.length}/${textLength}`
        }
      />
    );
  }
);

export default TkTextArea;
